import Image from '@common/image';
import styles from '@components/match/matchTab/matchList/matchListCard/matchListCard.module.scss';
import LikeButton from '@components/match/matchTab/matchList/LikeButton';
import classnames from 'classnames/bind';

const cx = classnames.bind(styles);

interface EmptyMatchListCardProps {
  companyName?: string;
  positionName?: string;
  companyLogoUrl?: string;
  matchingStatusLastModifiedDateText?: string;
  isClosed?: boolean;
  matchStatusText?: string;
  likeYn?: boolean;
}

const EmptyMatchListCard = ({
  companyName,
  positionName,
  companyLogoUrl,
  matchingStatusLastModifiedDateText,
  isClosed,
  matchStatusText,
  likeYn,
}: EmptyMatchListCardProps) => {
  return (
    <div className={cx('container', { closed: isClosed })}>
      <div className={cx('image')}>
        <Image width={48} height={48} src={`${companyLogoUrl}`} alt={`${companyName}`} />
      </div>

      <div className={cx('infoContainer')}>
        <div className={cx('infoTitleContainer')}>
          <div className={cx('overflowHidden')}>
            <div className={cx('infoTitle')}>{positionName}</div>
          </div>
          <LikeButton isLiked={!!likeYn} onClick={async () => {}} />
        </div>
        <div className={cx('infoSubContainer')}>
          <div>{companyName}</div>
        </div>
      </div>
      <div className={cx('modifiedDate')}>{matchingStatusLastModifiedDateText}</div>
      <div className={cx('matchStatus')}>{matchStatusText}</div>
    </div>
  );
};

export default EmptyMatchListCard;
